module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-cmn-01fd7d688896fb381c26a1e37533bcae.svg";